import { render, staticRenderFns } from "./Message.vue?vue&type=template&id=82011a78&scoped=true&"
import script from "./Message.vue?vue&type=script&lang=ts&"
export * from "./Message.vue?vue&type=script&lang=ts&"
import style0 from "./Message.vue?vue&type=style&index=0&id=82011a78&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82011a78",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/code/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('82011a78')) {
      api.createRecord('82011a78', component.options)
    } else {
      api.reload('82011a78', component.options)
    }
    module.hot.accept("./Message.vue?vue&type=template&id=82011a78&scoped=true&", function () {
      api.rerender('82011a78', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "module/Deals/view/vue/components/Message.vue"
export default component.exports